// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.EyeHidden = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EyeHidden = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var EyeHidden = _exports.EyeHidden = function EyeHidden(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M1.213 2.16a.75.75 0 0 0-.925 1.18l18.5 14.5a.75.75 0 0 0 .925-1.18l-3.288-2.575c1.238-1.27 2.075-2.691 2.497-3.7a1 1 0 0 0 0-.77c-.466-1.115-1.444-2.74-2.906-4.096C14.547 4.15 12.526 3 10 3c-2.131 0-3.906.822-5.29 1.9zM5.93 5.856C7.063 5.053 8.422 4.5 10.001 4.5c2.037 0 3.712.925 4.996 2.116C16.2 7.735 17.031 9.063 17.457 10c-.394.875-1.144 2.088-2.216 3.153l-1.681-1.318c.284-.55.443-1.172.443-1.835a4 4 0 0 0-6.631-3.015zm6.41 5.025L9.794 8.885A2 2 0 0 0 9.938 7.5H10a2.5 2.5 0 0 1 2.34 3.381m.294 4.072A6.65 6.65 0 0 1 10 15.5c-2.037 0-3.712-.925-4.997-2.115C3.8 12.265 2.97 10.938 2.543 10c.26-.575.673-1.297 1.232-2.025l-1.178-.928c-.712.928-1.222 1.853-1.519 2.569a1 1 0 0 0 0 .769c.466 1.115 1.444 2.74 2.907 4.096 1.468 1.37 3.49 2.52 6.015 2.52 1.494 0 2.81-.404 3.944-1.016zM6 10a4 4 0 0 0 5.194 3.819l-1.756-1.381a2.52 2.52 0 0 1-1.678-1.322L6.006 9.735q-.009.13-.009.265z"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "prefix__a"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M0 0h20v20H0z"
    }))));
  };
});
